import React, { memo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button, Icon, IconButton, Stack, Tooltip, useMediaQuery } from 'investira.react.components';
import { CarteirasTemplate } from '../../components/templates';
import withCarteiras from '../../hoc/withCarteiras';
import { useCarteirasContext } from '../../contexts/CarteirasContext';
import { acCarteiraSelected } from '../../store/actions';
import usePerfil from '../../hooks/usePerfil';
const Carteiras = memo(props => {
  const navigate = useNavigate();
  const {
    actions
  } = useCarteirasContext();
  const isUpSm = useMediaQuery(theme => theme.breakpoints.up('sm'));
  const storeDispatch = useDispatch();
  const {
    usuarioPrioridade
  } = usePerfil();
  useEffect(() => {
    storeDispatch(acCarteiraSelected({}));
  }, []);
  return <CarteirasTemplate title="Carteiras" headerRenderActions={usuarioPrioridade <= 6 && <Stack direction="row" spacing={2}>
            <Button disabled={props.disabledButtons} variant="contained" color="primary" startIcon={<Icon iconName="insert" size={16} />} size="small" sx={{
      px: 2
    }} onClick={() => navigate('/carteiras/add')}>
              {isUpSm ? 'Nova Carteira' : 'Nova'}
            </Button>
            <Tooltip title={'Atualizar lista de carteiras'}>
              <IconButton color={'primary'} onClick={() => props.readCarteiras()}>
                <Icon size={21} iconName={'refresh'} />
              </IconButton>
            </Tooltip>
          </Stack>} dataGridProps={{
    data: props.carteiras,
    readData: props.readCarteiras,
    isLoading: props.isLoading,
    initialState: {
      pagination: props.pagination,
      density: 'comfortable'
    },
    manualPagination: true,
    getRowId: row => {
      return row.carteira_id;
    },
    state: {
      isLoading: props.isLoading,
      pagination: props.pagination,
      showProgressBars: props.isRefetching,
      rowSelection: props.rowSelection
    },
    rowCount: props.rowCount,
    onPaginationChange: props.setPagination,
    onRowSelectionChange: props.setRowSelection,
    onFavClick: props.favCarteira,
    onEditClick: actions.handleEditCarteira,
    onDeleteClick: props.deleteCarteira,
    onBulkDeleteClick: props.bulkDeleteCarteiras,
    onSwitchChange: props.conferenciaCarteira
  }} />;
});
Carteiras.displayName = 'Carteiras';
export default withCarteiras(Carteiras);
